export const  REQUEST_CREATE_ROLE = 'REQUEST_CREATE_ROLE';
export const  CREATE_ROLE_FAILED = 'CREATE_ROLE_FAILED';
export const  CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const  REQUEST_GET_ROLE = 'REQUEST_GET_ROLE';
export const  GET_ROLE_FAILED = 'GET_ROLE_FAILED';
export const  GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const REQUEST_ASSIGN_ROLE = 'REQUEST_ASSIGN_ROLE';
